export default __webpack_public_path__ + "static/edition-logo-2322e18cf53afae60d672caf3d3d1d48.svg";